import SalesAnalyticsDashboard from "./sales-analytics";

export default function ClientManagementDashboard() {
  return <SalesAnalyticsDashboard />;
}
